<template>
  <div class="ml-1 mr-1">
    <b-row
      v-if="!hideHeader && (showType == 'form-viewer' || showType == 'e-form')"
    >
      <b-col>
        <form-viewer-header :formHeader="formHeader" />
      </b-col>
    </b-row>
    <div id="form-paginator" class="d-flex justify-content-center bg-white" style="position: relative;
    z-index: 100;" v-if="totalPages > 1">
      <b-link :disabled="loadingPage || currentPage == 0" variant="primary" @click="setCurrentPage({
          page: currentPage - 1
        })"><i class="fa fa-angle-left"></i> Prev</b-link>
        <span class="pl-2 pr-2">Page {{currentPage + 1}} of {{totalPages}}</span>
      <b-link :disabled="loadingPage || currentPage == totalPages - 1" variant="primary" @click="setCurrentPage({
          page: currentPage + 1
        })">Next <i class="fa fa-angle-right"></i></b-link>
    </div>
    <div>
      <component
        :is="getElementComponentData('Row', row.version)"
        :key="rowIndex"
        :properties="row.properties"
        :id="row.id + componentIdSuffix"
        v-for="(row, rowIndex) in json.rows"
        :form="formProp"
        :showType="showType"
        :ref="'row' + rowIndex"
        :containsPageBreak="json.rows[rowIndex].columns[0].components[0].elType == 'PageBreak'"
        v-show="
          json.rows[rowIndex].columns[0].components[0].elType != 'PageBreak' &&   
          (componentsIdSuffix || json.rows[rowIndex].columns[0].components[0].page  == currentPage) && 
          hiddenValues[rowIndex].some((e) => e !== true)"
      >
        <component
          :is="getElementComponentData('Column', column.version)"
          :key="columnIndex"
          :properties="column.properties"
          :id="column.id + componentIdSuffix"
          :showType="showType"
          :componentsIdSuffix="componentsIdSuffix"
          :form="formProp"
          v-for="(column, columnIndex) in row.columns"
          :cols="null"
          :ref="'row' + rowIndex + 'column' + columnIndex"
        >
          <fb-form-viewer
            :json="column.layout"
            :showType="showType"
            :results="results"
            v-if="column.layout"
            :ref="'row' + rowIndex + 'column' + columnIndex + 'layout'"
          >
          </fb-form-viewer>
          <div class="components text-left" v-if="column.components">
            <div
              class="mt-1 ml-1 mr-1 p-1 rounded position-relative"
              :key="componentIndex"
              v-for="(component, componentIndex) in column.components"
            >
              <component
                :is="getElementComponentData(component.elType, component.version)"
                :id="component.id + componentIdSuffix"
                :componentsIdSuffix="componentsIdSuffix"
                :properties="component.properties"
                :showType="showType"
                :results="results"
                :page="component.page ? component.page : currentPage"
                @update-child-control-value="updateControlValue"
                @change-hidden-property="
                  changeHiddenValue(rowIndex, columnIndex, $event)
                "
                @mount-done="updateChildMounted()"
                :form="formProp"
                :patient="patient"
                class="fb-component"
                :ref="
                  'row' +
                  rowIndex +
                  'column' +
                  columnIndex +
                  'component' +
                  componentIndex
                "
              />
            </div>
          </div>
        </component>
      </component>
    </div>
    <div id="bottom-form-paginator" class="d-flex justify-content-center bg-white"  style="position: relative;
    z-index: 100;" v-if="totalPages > 1">
      <b-link :disabled="loadingPage || currentPage == 0" variant="primary" @click="setCurrentPage({
          page: currentPage - 1
        })"><i class="fa fa-angle-left"></i> Prev</b-link>
        <span class="pl-2 pr-2">Page {{currentPage + 1}} of {{totalPages}}</span>
      <b-link :disabled="loadingPage || currentPage == totalPages - 1" variant="primary" @click="setCurrentPage({
          page: currentPage + 1
        })">Next <i class="fa fa-angle-right"></i></b-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  getElementComponentData,
  getFormBuilderComponents
} from "../../helpers/formBuilder";
import FormViewerHeader from "./FormViewerHeader";

export default {
  name: "FormViewer",
  components: { FormViewerHeader },
  props: [
    "json",
    "showType",
    "results",
    "form",
    "componentsIdSuffix",
    "document",
    "hideHeader",
    "patient",
    "formHeader"    
  ],
  data() {
    return {
      hiddenValues: [],
      childsMountedCount: 0,
      componentsToAwaitCount: 0,
      totalPages: 1
    };
  },
  beforeMount() {
    for (let rowIndex = 0; rowIndex < this.json.rows.length; rowIndex++) {
      this.hiddenValues[rowIndex] = [];
      const row = this.json.rows[rowIndex];
      for (
        let columnIndex = 0;
        columnIndex < row.columns.length;
        columnIndex++
      ) {
        const column = row.columns[columnIndex];
        if (column.components) {
          if (column.components[0].elType == 'PageBreak') {
            this.totalPages ++;
          }
          for (
            let componentIndex = 0;
            componentIndex < column.components.length;
            componentIndex++
          ) {
            const component = column.components[componentIndex];
            if (component.properties.hidden !== true) {
              this.hiddenValues[rowIndex][columnIndex] = false;
            } else {
              this.hiddenValues[rowIndex][columnIndex] = true;
            }
          }
        }
      }
    }
    this.$emit("updateTotalPages", this.totalPages);

    let components = getFormBuilderComponents({ layout: this.json });
    let componentsToAwait = [
      "ClientVitals",
      "ClientAllergies",
      "ClientMedications",
      "ActiveMedications",
      "ClientDiagnosisCodes",
      "FormDropdown",
      "TreatmentPlanObjectives"
    ];
    this.componentsToAwaitCount = components.filter(
      (c) => componentsToAwait.indexOf(c.elType) >= 0
    ).length;
  },
  mounted() {
    if (this.componentsToAwaitCount == 0){
      this.$emit("mounted", this.getBakedLayout());
    }
  },
  methods: {
    ...mapActions("formSubmitter", ["setCurrentPage"]),
    updateChildMounted() {
      this.childsMountedCount += 1;
      if (this.childsMountedCount == this.componentsToAwaitCount) {
        this.$emit("mounted", this.getBakedLayout());
      }
    },
    getElementComponentData(elementName, elementVersion) {
      return getElementComponentData(elementName, elementVersion).componentName;
    },
    updateControlValue(data) {
      this.$emit("update-child-control-value", data);
    },
    changeHiddenValue(rowIndex, columnIndex, hiddenValue) {
      if (this.hiddenValues[rowIndex][columnIndex] == hiddenValue) {
        return;
      }

      //make a copy of the row
      const newRow = this.hiddenValues[rowIndex].slice(0);
      // update the value
      newRow[columnIndex] = hiddenValue;
      // update it in the grid
      this.$set(this.hiddenValues, rowIndex, newRow);
    },
    getBakedLayout() {
      let bakedLayout = "";
      for (let rowIndex = 0; rowIndex < this.json.rows.length; rowIndex++) {
        if (this.hiddenValues[rowIndex].some((e) => e !== true)) {
          const row = this.json.rows[rowIndex];
          let rowBakedLayout = this.$refs[`row${rowIndex}`][0].getBakedLayout();
          let columnsBakedLayout = "";
          for (
            let columnIndex = 0;
            columnIndex < row.columns.length;
            columnIndex++
          ) {
            const column = row.columns[columnIndex];
            let columnBakedLayout =
              this.$refs[
                `row${rowIndex}column${columnIndex}`
              ][0].getBakedLayout();

            if (column.components) {
              let componentsBakedLayout = `<div class="components text-left">`;
              for (
                let componentIndex = 0;
                componentIndex < column.components.length;
                componentIndex++
              ) {
                let componentBakedLayout =
                  this.$refs[
                    `row${rowIndex}column${columnIndex}component${componentIndex}`
                  ][0].getBakedLayout();
                componentsBakedLayout += `<div class="mt-1 ml-1 mr-1 p-1 rounded position-relative">${componentBakedLayout}</div>`;
              }
              componentsBakedLayout += "</div>";
              columnBakedLayout = columnBakedLayout.replace(
                "<slot></slot>",
                componentsBakedLayout
              );
            } else if (column.layout) {
              let columnLayoutBakedLayout =
                this.$refs[
                  `row${rowIndex}column${columnIndex}layout`
                ][0].getBakedLayout();
              columnBakedLayout = columnBakedLayout.replace(
                "<slot></slot>",
                columnLayoutBakedLayout
              );
            }
            columnsBakedLayout += columnBakedLayout;
          }
          rowBakedLayout = rowBakedLayout.replace(
            "<slot></slot>",
            columnsBakedLayout
          );
          bakedLayout += rowBakedLayout;
        }
      }
      return bakedLayout;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      currentPage: state => state.form.currentPage,
      loadingPage: state => state.loadingPage
    }),
    componentIdSuffix() {
      return this.componentsIdSuffix ? this.componentsIdSuffix : "";
    },
    formProp() {
      return this.form && this.results
        ? {
            ...this.form,
            showType: this.showType
          }
        : null;
    },
    formHeaderProp() {
      return this.form
        ? {
            ...this.form,
            showType: this.showType
          }
        : this.form;
    }
  }
};
</script>

<style scoped>
div >>> .dropdown-menu {
  width: 100%;
}

@media print {
  iframe {
    display: none;
  }
}

a.disabled {
  pointer-events: none;
  color: #bbb;
}
</style>
